import { gql } from 'apollo-angular';

/**
 * Meta info schema
 */
export class MetaInfoSchema {
	static readonly serverTime = gql`
		query {
			servermetainfo {
				serverTime
			}
		}
	`;
}
